module.exports = __webpack_public_path__ + "img/kochava.png";